module.exports = {
    env: 'mandi',
    baseURL: {
        BASE_URL: process.env.REACT_APP_BASE_URL,
    },
    featureFlags: {
        ShowNflBrand: true,
        brandName: 'Asra Soft',
    },
};
